module.exports = __webpack_public_path__ + "static/daemon-6f71f92894f58e33a63c9eb2edd8a28c.jpg";